import { render } from "./opinion-bar.vue?vue&type=template&id=41a8fdf1"
import script from "./opinion-bar.vue?vue&type=script&lang=js"
export * from "./opinion-bar.vue?vue&type=script&lang=js"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__